import Loadable from 'react-loadable';
import Loading from '@/components/loading';

const LoadableTestPlan = Loadable({
  loader: async () => import('@/pages/testPlan'),
  loading: Loading
});
const LoadableHome = Loadable({
  loader: async () => import('@/pages/home'),
  loading: Loading
});
const LoadableDashboard = Loadable({
  loader: async () => import('@/pages/home'),
  loading: Loading
});
const LoadableLogin = Loadable({
  loader: async () => import('@/pages/loginPage/loginPage'),
  loading: Loading
});
const LoadableModal = Loadable({
  loader: async () => import('react-bootstrap/Modal'),
  loading: Loading
});
const LoadableUserManagement = Loadable({
  loader: async () => import('@/pages/userManagementPage/userManagementPage'),
  loading: Loading
});
const LoadableUserProfileManagement = Loadable({
  loader: async () => import('@/pages/userManagementPage/userProfileManagementPage'),
  loading: Loading
});
const LoadableUserPackageHistory = Loadable({
  loader: async () => import('@/pages/userManagementPage/userPackageHistory'),
  loading: Loading
});
const LoadableUserFactoryManagement = Loadable({
  loader: async () => import('@/pages/userManagementPage/userFactoryManagement'),
  loading: Loading
});
const LoadableProfile = Loadable({
  loader: async () => import('@/pages/profilePage/profilePage'),
  loading: Loading
});
const LoadableSetting = Loadable({
  loader: async () => import('@/pages/settingPage/settingPage'),
  loading: Loading
});

const LoadableReport = Loadable({
  loader: async () => import('@/pages/reportPage/reportPage'),
  loading: Loading
});
const LoadableAdminManagement = Loadable({
  loader: async () => import('@/pages/adminAccountManagementPage/adminAccountManagementPage'),
  loading: Loading
});
const LoadableAdminAccountEditPage = Loadable({
  loader: async () => import('@/pages/adminAccountManagementPage/adminAccountEditPage'),
  loading: Loading
});

const LoadableDashboardPage = Loadable({
  loader: async () => import('@/pages/dashboardPage/dashboardPage'),
  loading: Loading
});

export const TestPlan = LoadableTestPlan;
export const Home = LoadableHome;
export const Dashboard = LoadableDashboard;
export const ModalDialog = LoadableModal;
export const LoginPage = LoadableLogin;
export const UserManagement = LoadableUserManagement;
export const UserProfileManagement = LoadableUserProfileManagement;
export const UserPackageHistory = LoadableUserPackageHistory;
export const UserFactoryManagement = LoadableUserFactoryManagement;
export const ProfilePage = LoadableProfile;
export const SettingPage = LoadableSetting;
export const ReportPage = LoadableReport;
export const AdminAccountManagement = LoadableAdminManagement;
export const AdminAccountEdit = LoadableAdminAccountEditPage;
export const DashboardPage = LoadableDashboardPage;
